module.exports = __webpack_public_path__ + "img/ban_3.089b2e10.png";